import { empty as emptyFilter } from '@utils'

export const SALARY_LIST_COLUMNS = [
    {
        dataIndex: 'fullName',
        title: '姓名',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'idNumber',
        title: '身份证号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'teamName',
        title: '班组',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'enterpriseName',
        title: '归属单位',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'wages',
        title: '工资金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'cashAdvances',
        title: '预支现金',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'amountDeducted',
        title: '扣除金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'wagesToBePaid',
        title: '应发金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'orgCode',
        title: '开户银行',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'orgName',
        title: '开户银行全称',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'bankCard',
        title: '收款账号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'remark',
        title: '备注',
        width: 200,
        customRender: val => emptyFilter(val)
    }
]


export const SALARY_CONFIRM_SUC_LIST_COLUMNS = [
    {
        dataIndex: 'fullName',
        title: '姓名',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'idNumber',
        title: '身份证号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'teamName',
        title: '班组',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'enterpriseName',
        title: '归属单位',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'wagesToBePaid',
        title: '工资表应发金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'netWages',
        title: '银行发放金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'orgCodeText',
        title: '开户银行',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'orgName',
        title: '开户银行全称',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'bankCard',
        title: '收款卡号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'serialNumbers',
        title: '银行流水号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'stateText',
        title: '核准结果',
        width: 200,
        customRender: val => emptyFilter(val)
    }
]

export const SALARY_CONFIRM_FAIL_LIST_COLUMNS = [
    {
        dataIndex: 'fullName',
        title: '姓名',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'idNumber',
        title: '身份证号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'teamName',
        title: '班组',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'enterpriseName',
        title: '归属单位',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'wagesToBePaid',
        title: '工资表应发金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'netWages',
        title: '银行发放金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'reason',
        title: '原因说明',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        key: 'action',
        title: '操作',
        width: 100,
        fixed: 'right',
        scopedSlots: {
            customRender: 'action'
        }
    }
]

export const BANK_UNCONFIRM_LIST_COLUMNS = [
    {
        dataIndex: 'serialNumbers',
        title: '银行流水号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'flowDirectionText',
        title: '类型',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'operationTime',
        title: '发生时间',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'flowTypeText',
        title: '账户类型',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'bankAccountName',
        title: '账户名称',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'bankCard',
        title: '账户号码',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'orgCodeText',
        title: '开户银行',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'orgName',
        title: '开户银行全称',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'netWages',
        title: '金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'stateText',
        title: '异常原因',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'reason',
        title: '原因说明',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        key: 'action',
        title: '操作',
        width: 100,
        fixed: 'right',
        scopedSlots: {
            customRender: 'action'
        }
    }
]


